import * as React from 'react';
import { Alert, Spinner } from "react-bootstrap";
import { connect } from 'react-redux';
import { Route } from "react-router";
import { getLifeBankingDetailsPage, getLifePolicyDetails, setLifeActiveBenefitId } from "../../actions/lifePolicyActions";
import { navigateTo } from '../../actions/navigationActions';
import { hideMobileProfile, setSelectedLifeCover } from '../../actions/profileActions';
import { DASHBOARD, LIFE_ADD_BENEFICIARY, LIFE_BENEFICIARY_DETAIL, LIFE_CHANGE_DEBIT_ORDER_DATE, LIFE_INSURANCE, LIFE_INSURANCE_BENEFIT, LIFE_INSURANCE_POLICY_DETAILS, LIFE_UPDATE_BENEFICIARIES, LIFE_UPDATE_BENEFICIARY_DETAILS, LIFE_UPDATE_POLICY_PAYOUT } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import LifeAddBeneficiary from "./LifeAddBeneficiary";
import LifeBeneficiaryDetail from "./LifeBeneficiaryDetail";
import LifeChangeDebitOrderDate from "./LifeChangeDebitOrderDate";
import './LifeInsurance.css';
import LifeInsuranceCard from "./LifeInsuranceCard";
import LifeInsurancePolicyDetails from './LifeInsurancePolicyDetails';
import LifeUpdateBeneficiaries from "./LifeUpdateBeneficiaries";
import LifeUpdateBeneficiaryDetails from "./LifeUpdateBeneficiaryDetails";
import LifeUpdatePolicyPayout from "./LifeUpdatePolicyPayout";

class LifeInsurance extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            benefitIconMap: {
                'MLF': './Images/OnlineQuotes/LifeInsurance/icon-funeral-cover.svg',
                'LLC_F': './Images/OnlineQuotes/LifeInsurance/icon-funeral-cover.svg',
                'LC': './Images/OnlineQuotes/LifeInsurance/icon-life-insurance-cover.png',
                'LC_ACC': './Images/OnlineQuotes/LifeInsurance/icon-life-insurance-cover.png',
                'CI30': './Images/OnlineQuotes/LifeInsurance/icon-critical-illness-cover.png',
                'CI30_ACC': './Images/OnlineQuotes/LifeInsurance/icon-critical-illness-cover.png',
                'DC': './Images/OnlineQuotes/LifeInsurance/icon-disability-cover.png',
                'DC_ACC': './Images/OnlineQuotes/LifeInsurance/icon-disability-cover.png',
                'SP90': './Images/OnlineQuotes/LifeInsurance/icon-salary-protection.png',
                'SP90_ACC': './Images/OnlineQuotes/LifeInsurance/icon-salary-protection.png',
            },
            showChangedDebitOrderDateNotification: false,
        }
        
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
        this.handleChangeDebitOrderDate = this.handleChangeDebitOrderDate.bind(this);
        this.dismissShowChangedDebitOrderDateNotification = this.dismissShowChangedDebitOrderDateNotification.bind(this);
        this.handlePersistChangeDebitOrderDate = this.handlePersistChangeDebitOrderDate.bind(this);
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleCoverRedirect(e) {
        const isMobile = window.innerWidth <= 975;
        const benefitId = e.target.getAttribute('data-benefit-id');
        this.props.dispatchSetActiveBenefitId(benefitId);
        if (isMobile) {
            this.props.redirectTo(LIFE_INSURANCE_POLICY_DETAILS);
        }
    }
    
    handleChangeDebitOrderDate() {
        this.handleRedirect(LIFE_CHANGE_DEBIT_ORDER_DATE); 
    }
    
    handlePersistChangeDebitOrderDate() {
        this.setState({
            ...this.state,
            showChangedDebitOrderDateNotification: true
        });
        this.handleRedirect(LIFE_INSURANCE);
    }
    
    dismissShowChangedDebitOrderDateNotification() {
        this.setState({
            ...this.state,
            showChangedDebitOrderDateNotification: false,
        });
    }

    async componentDidMount() {
        this.props.dispatchHideProfile();
        
        this.props.dispatchGetLifePolicyDetails();
        this.props.dispatchGetLifeBankingDetailsPage(8, 0);
        
        const mandateStatus = this.props.lifePolicy.policy?.mandateStatus;
        if (mandateStatus == 'pending') {
            this.setState({
                ...this.state,
                showChangedDebitOrderDateNotification: true,
            })
        }
    }

    public render() {
        let policy = this.props.lifePolicy?.policy;
        let mandateStatus = policy?.mandateStatus;
        
        let BreadcrumbDetails = [
            { destination: DASHBOARD, description: "Home" },
            { destination: LIFE_INSURANCE, description: "Livin' Policy" },
            { destination: LIFE_UPDATE_BENEFICIARIES, description: "Update Beneficiaries" },
            { destination: LIFE_UPDATE_BENEFICIARIES, description: "Beneficiary Detail" },
            { destination: LIFE_CHANGE_DEBIT_ORDER_DATE, description: "Change Debit Order Date" },
            { destination: LIFE_UPDATE_BENEFICIARY_DETAILS, description: "Update details" },
        ]
        
        if (!policy) {
            this.props.dispatchModalSomethingWentWrong();
            this.handleRedirect(DASHBOARD);
        }

        let covers = <>
            <div className="Life-insurance-card" id="0" >
                { this.props.lifePolicy?.policy?.benefits?.map((benefit) => 
                        <LifeInsuranceCard 
                        active={this.props.lifePolicy?.policy?.activeBenefitId === benefit.id}
                        id={benefit.id}
                        alertCount="1"
                        headerText={benefit.name}
                        bodyText={benefit.benefitAmountText ? benefit.benefitAmountText : benefit.benefitAmount}
                        premium={benefit.premiumAmount}
                        code={benefit.productCode}
                        image={this.state.benefitIconMap[benefit.productCode]}
                        />
                 )}
            </div>
        </>

        let defaultDisplay = <>
            <div id="LifeInsurance" className="Life-insurance life-insurance__package-card package-card card col-12 mb-3">
                <div className="card-body">
                    <div className="my-2">
                        <h1 className="package-card__title">Livin' policy</h1>
                    </div>
                    <p className="package-card__premium-text mb-lg-1">Total monthly premium</p>
                    <h3 className="package-card__premium-amount">R { this.props.lifePolicy?.policy?.premium } pm</h3>
                    <hr className="life-divider" />
                    <div className="row justify-content-between">
                        { this.props.lifePolicy.policy?.bankingDetails?.nextDebitOrderDate && <div className="col-auto">
                            <p className="pColor mb-0">Next debit order</p>
                            { !this.props.lifePolicy.metadata?.bankingDetails?.loading && <p className="pColor pDetails"><b>{ this.props.lifePolicy?.policy?.bankingDetails?.nextDebitOrderDate }</b></p>
                            || <Spinner className="d-block mx-auto my-2" animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                            }
                        </div> }
                        <div className="col-5 col-lg-5">
                            <p className="pColor mb-0">Policy no.</p>
                            <p className="pColor pDetails"><b>{policy.name}</b></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <button className="package-card__button btn btn-outline-red mb-3" onClick={this.handleChangeDebitOrderDate} id="EditPolicy">Change debit order date</button>
                        </div>
                    </div>
                </div>
            </div>
            {covers}
        </>

        return (
            <div id="LifeInsurance" className="mb-4 Life-insurance-base">
                { this.props.router.location && <KPBreadCrumb navList={BreadcrumbDetails.filter((detail) => this.props.router.location.pathname.indexOf(detail.destination) > -1)} /> }
                <>
                    <div>
                        <div className="d-none d-lg-block mb-3 float-left col-lg-12 col-xl-4 pl-0 pr-0">
                            {defaultDisplay}
                        </div>
                        <div className="mb-3 float-right col-12 col-xl-8 pl-3 pr-0">
                            <>
                                { (this.state.showChangedDebitOrderDateNotification && mandateStatus == 'pending') && 
                                    <Alert onClose={this.dismissShowChangedDebitOrderDateNotification} variant="success" className="d-flex justify-content-between">
                                        You’ve successfully changed your debit order date, please confirm the debit order with your bank
                                        <button onClick={this.dismissShowChangedDebitOrderDateNotification}><img src="./Images/icons-navigation-close-24-px-white.svg" /></button>
                                    </Alert> 
                                }
                            </>
                        
                            <Route exact path={LIFE_INSURANCE} component={LifeInsurancePolicyDetails} />
                            <Route exact path={LIFE_INSURANCE_BENEFIT} component={LifeInsurancePolicyDetails} />
                            <Route exact path={LIFE_UPDATE_BENEFICIARIES} component={LifeUpdateBeneficiaries} />
                            <Route exact path={LIFE_ADD_BENEFICIARY} component={LifeAddBeneficiary} />
                            <Route exact path={LIFE_BENEFICIARY_DETAIL} component={LifeBeneficiaryDetail} />
                            <Route exact path={LIFE_UPDATE_BENEFICIARY_DETAILS} component={LifeUpdateBeneficiaryDetails} />
                            <Route exact path={LIFE_UPDATE_POLICY_PAYOUT} component={LifeUpdatePolicyPayout} />
                            <Route exact path={LIFE_CHANGE_DEBIT_ORDER_DATE} render={(props) => <LifeChangeDebitOrderDate emitHandlePersistChangeDebitOrderDate={this.handlePersistChangeDebitOrderDate} />} />
                        </div>
                    </div>
                </>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        router: state.router,
        profile: state.profile,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetSelectedLifeCover: (id) => dispatch(setSelectedLifeCover(id)),
        dispatchSetActiveBenefitId: (id) => dispatch(setLifeActiveBenefitId(id)),
        dispatchGetLifePolicyDetails: () => dispatch(getLifePolicyDetails('')),
        dispatchGetLifeBankingDetailsPage: (count: number, skip: number, more?: boolean) => dispatch(getLifeBankingDetailsPage(count, skip, more)),
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeInsurance);